var _path;
import * as React from "react";
function SvgComboInsightsVerticalBorderPositive(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.028 7.428a2.5 2.5 0 011.472 2.28V59a1.5 1.5 0 01-1.5 1.5H4A1.5 1.5 0 012.5 59V9.707a2.5 2.5 0 011.472-2.279l12.411-5.601a1.5 1.5 0 011.234 0l12.411 5.601z"
  })));
}
export default SvgComboInsightsVerticalBorderPositive;